export default __webpack_public_path__ + "static/media/logo.a5017458.svg";